module.exports = __webpack_public_path__ + "static/2-google-basics-of-ux-b8131e44ce0def2d179afcbef9546760.png";